import { InfoCircleFilled } from '@ant-design/icons';
import { styled } from 'styled-components';

const LeadingText = styled.div`
    color: white;
    display: flex;
    background: #cb212f;
    border-radius: 1rem-;
    margin-top: 10px;
    font-size: 15px;
`;

export function ConfirmSubmitText() {
    return (
        <LeadingText>
            <div
                style={{
                    margin: 'auto'
                }}
            >
                <InfoCircleFilled style={{ fontSize: 36, padding: '2rem' }} rev={undefined} />
            </div>
            <div
                style={{
                    padding: '2rem 2rem 0.5rem 0'
                }}
            >
                <p style={{ fontWeight: 'bold' }}>
                    Po zagłosowaniu sprawdź swoją skrzynkę pocztową, aby potwierdzić głos.
                </p>
                <p
                    style={{
                        fontStyle: 'italic'
                    }}
                >
                    <strong>UWAGA.</strong> Jeżeli nie znajdziesz potwierdzenia głosowania, sprawdź
                    folder SPAM.
                </p>
            </div>
        </LeadingText>
    );
}

export default ConfirmSubmitText;
